import React from "react";
import Layout from "../components/organisms/layout/layout";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import SEO from "../shared/seo";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import RecentEditions from "../components/molecules/recent-editions/recentEditions";
import Paginator from "../components/molecules/paginator/Paginator";
import FeaturedEdition, {
  IFeaturedEdition,
} from "../components/molecules/featured-edition/featuredEdition";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import { calculateReadTime } from "../utils/calculateReadTime";

const TemplateEditoriales = (props: any) => {
  const pageData = props.pageContext.pageContent;
  const { slug, numPages, currentPage, elements } = props.pageContext;
  const keyName =
    pageData.referenciaCabecera && pageData.referenciaCabecera.tipoCabecera;
  const pageSlug = props.location.pathname;
  
  const adapterFeaturedEdition = (data: any) => {
    let process: IFeaturedEdition = {
      notas: data.map((nota: any) => ({
        tags: [pageData.nombreCategoria.split(" ")],
        titulo: nota.nombreSubcategoria,
        description: nota.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
          "."
        )[0] + ".",
        imageURL: nota.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
        slug: nota.slug,
        autor: nota.referenciaInterna.referenciaCabecera.referenciaAutor.nombreTab,
        fecha: dateToRelativeFormat(nota.createdAt),
        tiempo: `${calculateReadTime(nota.nombreSubcategoria)} minutos`,
      })),
    };
    return process;
  };
  
  return (
    <Layout
      hideHeaderDesktop={false}
      hideHeaderMobile={false}
      isNotRoot={true}
      headboard={pageData.referenciaCabecera || {}}
      showPlayer={true}
    >
      <SEO
        title={pageData.metaTitulo || pageData.nombreCategoria}
        slug={pageSlug}
        description={
          pageData.metaDescripcion &&
          pageData.metaDescripcion.json.content[0].content[0].value
        }
        image={
          pageData.referenciaCabecera.imagenHeader &&
          pageData.referenciaCabecera.imagenHeader.file.url
        }
        lang="es"
      />
      {pageData.referenciaOrganismos &&
        pageData.referenciaOrganismos.map(
          (value: ReferenciaOrganismos, index: number) => (
            <div key={index} className={keyName} id={`${keyName}${index}`}>
              <LibraryComponents
                content={value}
                categoryName={pageData.nombreCategoria}
              />
            </div>
          )
        )}
      <RecentEditions
        className="agrupadora"
        editions={elements.slice(0, 3).map((subcat) => ({
          tags: [pageData.nombreCategoria.split(" ")],
          title: subcat.nombreSubcategoria,
          description:
            subcat.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
              "."
            )[0] + ".",
          imageURL:
            subcat.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
          slug: subcat.slug,
          label: dateToRelativeFormat(subcat.createdAt),
          labelB: calculateReadTime(subcat.nombreSubcategoria) + ' minutos',
        }))}
      />
      <FeaturedEdition className="agrupadora"
        {...adapterFeaturedEdition(elements.slice(3,4))}
      />
      <RecentEditions
        className="agrupadora"
        editions={elements.slice(4).map((subcat) => ({
          tags: [pageData.nombreCategoria.split(" ")],
          title: subcat.nombreSubcategoria,
          description:
            subcat.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
              "."
            )[0] + ".",
          imageURL:
            subcat.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
          slug: subcat.slug,
          label: dateToRelativeFormat(subcat.createdAt),
          labelB: calculateReadTime(subcat.nombreSubcategoria) + ' minutos',
        }))}
      />
      <Paginator slug={slug} quantity={numPages} currentPage={currentPage} />
      <Disclaimer />
    </Layout>
  );
};

export default TemplateEditoriales;
